
// ABOUTME: Main referrer dashboard page with URL routing support
// ABOUTME: Displays referral statistics, featured roles, and user profile management

import React from 'react';
import ReferrerDashboard from '@/components/ReferrerDashboard';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleViewChange = (view: string) => {
    switch (view) {
      case 'submit':
        navigate('/role-hub');
        break;
      case 'public-profile':
        navigate('/my-profile');
        break;
      case 'hr-dashboard':
        navigate('/hr');
        break;
      case 'manage-roles':
        navigate('/manage-roles');
        break;
      case 'billing':
        navigate('/billing');
        break;
      case 'security-audit':
        navigate('/security-audit');
        break;
      default:
        navigate('/');
    }
  };

  return <ReferrerDashboard onViewChange={handleViewChange} />;
};

export default Dashboard;
